<template>
  <q-list class="no-focus q-px-none">
    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="credit_check_authorized" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          By submitting my order, I authorize Compare Power and {{ brand }} to perform all necessary tasks to establish
          my electricity service.
        </q-item-label>
      </q-item-section>
    </q-item>
    <div style="display: none">{{ all_agreed }}</div>
    <four-change-authorizations v-if="show_four_change"
                                v-model="four_change_agreed"></four-change-authorizations>
    <constellation-authorizations v-if="show_constellation"
                                  v-model="constellation_agreed"></constellation-authorizations>
    <just-energy-authorizations v-if="show_just_energy"
                                v-model="just_energy_agreed"></just-energy-authorizations>
    <next-era-authorizations v-if="show_next_era" v-model="next_era_agreed"></next-era-authorizations>
    <payless-authorizations v-if="show_payless" v-model="payless_agreed"></payless-authorizations>
    <flagship-authorizations v-if="show_flagship" v-model="flagship_agreed"></flagship-authorizations>
    <txu-authorizations v-if="show_txu_energy" v-model="txu_agreed"></txu-authorizations>
    <standard-authorizations v-if="show_standard" v-model="standard_agreed"></standard-authorizations>
  </q-list>

  <!--  <q-dialog v-model="privacy_policy" full-height>-->
  <!--    <q-card class="lt-sm" style="min-width: 100%">-->
  <!--      <q-card-actions>-->
  <!--        <q-btn label="Close" @click="privacy_policy = false" class="full-width"></q-btn>-->
  <!--      </q-card-actions>-->
  <!--      <iframe src="https://comparepower.com/privacy" frameborder="0"-->
  <!--              style="overflow:auto;height: 98%;width:100%"></iframe>-->
  <!--    </q-card>-->
  <!--    <q-card style="width: 80%; max-width: 1200px" class="gt-xs">-->
  <!--      <q-card-actions>-->
  <!--        <q-btn label="Close" @click="privacy_policy = false" class="full-width" color="black"></q-btn>-->
  <!--      </q-card-actions>-->
  <!--      <iframe src="https://comparepower.com/privacy" frameborder="0"-->
  <!--              style="overflow:hidden;height:92%;width:100%"></iframe>-->
  <!--    </q-card>-->
  <!--  </q-dialog>-->
</template>

<script>
import ComparePowerCard            from "components/ComparePowerCard";
import ComparePowerCardHeader      from "components/ComparePowerCardHeader";
import JustEnergyAuthorizations    from "components/order/authorizations/JustEnergyAuthorizations";
import NextEraAuthorizations       from "components/order/authorizations/NextEraAuthorizations";
import StandardAuthorizations      from "components/order/authorizations/StandardAuthorizations";
import ConstellationAuthorizations from "components/order/authorizations/ConstellationAuthorizations";
import FourChangeAuthorizations    from "components/order/authorizations/FourChangeAuthorizations";
import TxuAuthorizations           from "components/order/authorizations/TxuAuthorizations";
import SelectedPlan                from "src/composables/SelectedPlan";
import { computed, ref, watch }    from "vue";
import Utilities                   from "src/composables/Utilities";
import PaylessAuthorizations       from "components/order/authorizations/PaylessAuthorizations";
import Authorizations              from "src/composables/Authorizations";
import FlagshipAuthorizations      from "components/order/authorizations/FlagshipAuthorizations";

export default {
  name: "OrderAuthorizations",
  components: {
    TxuAuthorizations,
    FlagshipAuthorizations,
    PaylessAuthorizations,
    FourChangeAuthorizations,
    ConstellationAuthorizations,
    StandardAuthorizations,
    NextEraAuthorizations,
    JustEnergyAuthorizations,
    ComparePowerCardHeader,
    ComparePowerCard
  },
  props: {
    modelValue: {
      type: Boolean
    }
  },
  setup(props, { emit }) {

    const model = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    })

    const all_agreed = computed(() => {
      const value = credit_check_authorized.value
          && (!show_four_change.value || four_change_agreed.value)
          && (!show_constellation.value || constellation_agreed.value)
          && (!show_payless.value || payless_agreed.value)
          && (!show_just_energy.value || just_energy_agreed.value)
          && (!show_next_era.value || next_era_agreed.value)
          && (!show_flagship.value || flagship_agreed.value)
          && (!show_txu_energy.value || txu_agreed.value)
          && (!show_standard.value || standard_agreed.value)
      model.value = value;
    })

    const { selected_plan } = SelectedPlan();
    const { plan_brand } = Utilities();

    const brand = computed(() => plan_brand(selected_plan.value));


    const credit_check_authorized = ref(false);

    const show_four_change = computed(() => brand.value === '4Change Energy');
    const show_constellation = computed(() => brand.value === 'Constellation');
    const show_payless = computed(() => brand.value === 'Payless Power');
    const show_just_energy = computed(() => ['Just Energy', 'Amigo Energy', 'Tara Energy'].includes(brand.value));
    const show_txu_energy = computed(() => ['TXU Energy'].includes(brand.value));
    const show_next_era = computed(() => ['Gexa Energy', 'Frontier Utilities'].includes(brand.value));
    const show_flagship = computed(() => ['Flagship Power'].includes(brand.value));
    const show_standard = computed(() => !show_four_change.value && !show_constellation.value && !show_just_energy.value && !show_next_era.value && !show_payless.value && !show_flagship.value);

    const four_change_agreed = ref(false);
    const constellation_agreed = ref(false);
    const payless_agreed = ref(false);
    const just_energy_agreed = ref(false);
    const next_era_agreed = ref(false);
    const flagship_agreed = ref(false);
    const standard_agreed = ref(false);
    const txu_agreed = ref(false);

    const clear_authorizations = function () {
      credit_check_authorized.value = false;
      four_change_agreed.value = false;
      constellation_agreed.value = false;
      payless_agreed.value = false;
      just_energy_agreed.value = false;
      next_era_agreed.value = false;
      flagship_agreed.value = false;
      standard_agreed.value = false;
      txu_agreed.value = false;
    }

    return {
      brand,
      all_agreed,
      privacy_policy: ref(false),
      show_txu_energy,
      show_four_change,
      show_constellation,
      show_payless,
      show_just_energy,
      show_next_era,
      show_flagship,
      show_standard,
      four_change_agreed,
      constellation_agreed,
      next_era_agreed,
      payless_agreed,
      just_energy_agreed,
      flagship_agreed,
      txu_agreed,
      standard_agreed,
      credit_check_authorized
    }
  }
}
</script>

<style scoped>

</style>
